export default __webpack_public_path__ + "bayes_PB.png";